import { ReactElement } from 'react';
import { Container, CardIcon, Grid } from './styles';
import Divider from '@mui/material/Divider';

interface IProps {
  // icon: ReactElement;
  icon: string;
  title: string;
  color: string;
  footer: string;
  isLoading: boolean;
  isFetching: boolean;
  value: number;
}

const CardBalance = ({
  icon,
  title,
  color,
  footer,
  isLoading,
  isFetching,
  value,
}: IProps) => {
  return (
    <Container>
      <CardIcon color={color}>{icon}</CardIcon>

      <span>{title}</span>

      <div className="gridContainer">
        <Grid color={color}>
          <p className="cardValue">
            {value.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
            })}
          </p>
          <Divider className="divider" />

          <p className="footer">
            {isLoading || isFetching ? 'Carregando...' : footer}
          </p>
        </Grid>
      </div>
    </Container>
  );
};

export default CardBalance;
